import { resolveSemanticColor } from '@/theme/semanticTokens';
import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives/types';

type ThemeSxObject = Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;
type ThemeSxFn = (theme: Theme) => ThemeSxObject;

export const projectCsvValidationResultIconSize = 18;

export const projectCsvValidationResultContentSx: SxProps<Theme> = {
  position: 'relative',
  rowGap: s('md'),
};

export const projectCsvValidationResultTitleSx: ThemeSxFn = (theme) => ({
  fontSize: theme.typography.subtitle1.fontSize ?? 'inherit',
  lineHeight: theme.typography.subtitle1.lineHeight ?? 'normal',
  fontWeight: theme.typography.subtitle1.fontWeight,
});

export const projectCsvValidationResultTitleRowSx: ThemeSxFn = (theme) => ({
  display: 'block',
  paddingRight: { xs: 0, sm: '224px' },
  width: '100%',
  fontWeight: theme.typography.subtitle1.fontWeight,
});

export const projectCsvValidationResultFileRowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: s('xs'),
  minWidth: 0,
  fontWeight: 400,
};

export const projectCsvValidationResultFileLabelSx: ThemeSxFn = (theme) => ({
  flexShrink: 0,
  color: 'text.primary',
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: theme.typography.subtitle1.lineHeight,
  fontWeight: theme.typography.subtitle1.fontWeight,
});

export const projectCsvValidationResultFileNameSx: ThemeSxFn = (theme) => ({
  color: 'text.secondary',
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: theme.typography.subtitle1.lineHeight,
  minWidth: 0,
  overflowWrap: 'anywhere',
});

export const projectCsvValidationResultActionsSx: SxProps<Theme> = {
  position: { xs: 'static', sm: 'absolute' },
  top: 0,
  right: 0,
  flexShrink: 0,
  alignSelf: 'flex-start',
  pt: 0,
};

export const projectCsvValidationResultStatusRowSx = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  columnGap: s('3xl'),
  rowGap: s('md'),
  minHeight: '40px',
  width: '100%',
} as const;

export const projectCsvValidationResultStatusBlockSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: s('xs'),
  flexShrink: 0,
};

export const projectCsvValidationResultStatusTextSx: ThemeSxFn = (theme) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: s('sm'),
  fontSize: theme.typography.subtitle1.fontSize,
  flexShrink: 0,
  minWidth: 0,
});

export const buildProjectCsvValidationResultIconFrameSx =
  (tone: 'success' | 'error' | 'warning' | 'textSecondary'): ThemeSxFn =>
  (theme) => ({
    display: 'inline-flex',
    color: resolveSemanticColor(theme, tone),
  });
